<script setup lang="ts">
interface Props {
  title: string
  icon: string
  value: string | number
  description: string
}

const props = defineProps<Props>()
</script>

<template>
  <AppCard :title="title" :icon="icon">
    <p class="text-3xl font-bold">{{ value }}</p>
    <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">{{ description }}</p>
  </AppCard>
</template>
